// ts-nocheck
import CalculatePrice from '../../../shared/calculate-price.js';
// TODO: Artem: IMHO inclusion: true is not used ... maybe delete it
//import {loadStripe} from '@stripe/stripe-js/pure.js';
import {loadStripe} from '@stripe/stripe-js';

import {APIResponse} from '../../../server/routes/route-types.js'
import {CalculateSearchAPIResult, ReadQueryStatusAPIResult} from '../../../server/routes/api.js'
import {PublicKeyResponse, ReportOrderResponse} from '../../../server/routes/purchase.js'

// Interface for match table entry
interface MatchTableEntry {
	key: string;
	inclusion?: boolean;
	merge?: boolean;
	childRewrite?: string;
}

// Interface for match table
interface MatchTable {
	[key: string]: MatchTableEntry;
}

// Interface for list item
interface ListItem {
	module: string;
	value: string;
	version?: string;
	type?: string;
	child?: boolean;
}

// Interface for search params
interface SearchParams {
	list: ListItem[];
}

// Interface for query params
interface QueryParams {
	searchToken: string;
}

// Interface for suggestions params
interface SuggestionsParams {
	query: string;
	type: string;
	template: Template;
}

// Interface for template
interface Template {
	title: string;
	value: string;
	icon?: string;
	count?: string;
	list?: string;
}

// Interface for checkout params
interface CheckoutParams {
	count: number;
	details: string;
	checked: boolean;
	returnURL: string;
	reportName: string;
}

// Interface for domain item
interface DomainItem {
	country: wts_ignore_any;
	domain: string;
	rank: number;
	contacts: wts_ignore_any;
	hidden: boolean;
}

const ReportsMatchTable: MatchTable = {
	"Technology": { key: "Technology", inclusion: true },
	"Category": { key: "Category", inclusion: true },
	"Header": { key: "Header", inclusion: true },
	"Top Level Domains (TLD)": { key: "TLD", merge: true },
	"Regions": { key: "Region", childRewrite: "Country", merge: true },
	"Languages": { key: "Language", merge: true },
	"Custom": { key: "Custom", inclusion: true },
};

export const ReportsSearchEncode = function( params: SearchParams ): string {

	let list: wts_ignore_any[] = [];
	let mergeTable: { [key: string]: string[] } = {};

	//#Filter out data for merge
	for( const item of params.list ){

		const template = ReportsMatchTable[ item.module ];

		if( !template )
			continue;

		let key = template.key;

		if( template.childRewrite && item.child )
			key = template.childRewrite;

		if( template.merge ){

			if( !mergeTable[ key ] )
				mergeTable[ key ] = [];

			mergeTable[ key ].push( item.value );

			continue;
		};

		let object: wts_ignore_any = {
			[ key ]: item.value,
			Version: item.version
		};

		if( item.type === "include" || item.type === "exclude" ){
			object.Inclusion = item.type === "include";
		};

		list.push( object );
	};

	for( const key in mergeTable ){
		list.push({ [key]: mergeTable[ key ] });
	};

	return JSON.stringify( list );
};
export const ReportsSearch = function( params: SearchParams, dispatch: (action: [string, string]) => void ): void {

	//console.log( "fetch", params.list );

	let body = ReportsSearchEncode( params );

	fetch( "/api/calculateReportDomainCount", {
		method: "POST",
		headers: { 'Content-Type': 'application/json' },
		body: body
	}).then(( response ) => {
		return response.json();
	}).then(( untypedResponse: unknown ) => {

		const response = untypedResponse as APIResponse<CalculateSearchAPIResult>;

		if( !response.results || !response.results.searchId ){
			dispatch([ "search", "" ]);
			return;
		};

		dispatch([ "search", response.results.searchId ]);

	}).catch(( e ) => {
		dispatch([ "search", "" ]);
	});

};

export const ReportsSearchQuery = function( params: QueryParams, dispatch: (action: [string, wts_ignore_any]) => void ): void {

	fetch(
		"/api/readQueryStatus/" + params.searchToken
	).then(( response ) => {
		return response.json();
	}).then(( untypedResponse: unknown ) => {

		const apiResponse = untypedResponse as APIResponse<ReadQueryStatusAPIResult>;
		if( !apiResponse || !apiResponse.results || !apiResponse.results.results )
			return;

		const response = apiResponse.results;

		let list: DomainItem[] = [];

		for( const item of (response.results.sampleDomains || []) ){
			list.push({
				country: item.Country,
				domain: item.Domain,
				rank: item.Rank,
				contacts: item.Contacts,
				hidden: !!item.Hidden
			});
		};

		dispatch([ "progress", {
			progress: response.progress,
			discovered: response.results.domainCount,
			completed: response.completed,
			max: response.results.maxDomainsInReport,
			domains: list,
		}]);

	}).catch(( e ) => {});

};

const ReportsSuggestionsParse = function( item: wts_ignore_any, template: Template ): wts_ignore_any {

	let object: wts_ignore_any = {
		title: item[ template.title ],
		value: item[ template.value ],
		icon: item[ template.icon! ],
		count: item[ template.count! ] || 0,
		list: []
	};

	if( template.list && item[ template.list ] && Array.isArray( item[ template.list ] ) ){

		for( const child of item[ template.list ] ){
			object.list.push( ReportsSuggestionsParse( child, template ) );
		};

	};

	return object;
};
export const ReportsSuggestions = function( params: SuggestionsParams, dispatch: (action: [string, wts_ignore_any]) => void ): void {

	fetch(
		"/api/" + params.query
	).then(( response ) => {
		return response.json();
	}).then(( response: APIResponse<unknown> ) => {

		if( !response.results || !Array.isArray( response.results ) )
			return;

		let list: unknown[] = [];

		for( const item of response.results ){
			list.push( ReportsSuggestionsParse( item, params.template ) );
		};

		dispatch([ "suggested", {
			type: params.type,
			list: list
		}]);

	}).catch(( e ) => {});

};

function ReportsCheckoutBody( count: number, details: string, checked: boolean, returnURL: string, reportName: string ): string {

	const orderCriteria = reportName; // <- this is main search term /create-report?technology=Nginx
//	const orderURL = 'https://localhost:3001/create-report?technology=nginx'; // <- this is the URL the user will be redirected to after the order is canceled by the user
	const agreedWithTerms = checked; // Olesya you need to set it from "Agree with terms" checkbox

	const body = JSON.stringify({
		orderCriteria, // <- This is human-readable order description
		orderURL: returnURL, // <- this is the URL the user will be redirected to after the order is canceled by the user
		domainCount: count, // <--- this is the number of domains user selected in the slider
		price: CalculatePrice( count ), // <---- this is the price of the report as shown to the user (I believe we ignore that on the server. Just for logging)
		agreedWithTerms, // Olesya you need to set it from "Agree with terms" checkbox. It is a legal formality, we will log that on the server
		details: details // <--- these are filters that you send to /api/calculateReportDomainCount ... from "List of selected options" on the page
	});

	return body;
};

//import {loadStripe} from '@stripe/stripe-js';

export const ReportsCheckoutStripe = function( params: CheckoutParams, dispatch: (action: [string, wts_ignore_any]) => void ): void {

//	console.log(`ReportsCheckoutStripe: ${JSON.stringify(params)}`);
//	return;

	const requestBody = ReportsCheckoutBody(
		params.count,
		params.details,
		params.checked,
		params.returnURL,
		params.reportName
	);

//	console.log( "Data Data: ", requestBody );

	fetch('/purchase/public-key')
		.then(function (result) {
			return result.json();
		})
		.then(function (untypedPublicKeyResult: unknown) {

			const publicKeyResult = untypedPublicKeyResult as APIResponse<PublicKeyResponse>;
			if (!publicKeyResult.err) {

				loadStripe(publicKeyResult.results!.publicKey).then((stripe) =>{

				// Create the checkout session.
				fetch('/purchase/report', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: requestBody

				}).then(function (result) {
					return result.json();
				}).then(function (untypedData: unknown) {

					const data = untypedData as APIResponse<ReportOrderResponse>;
					if (!data.err) {
						console.log(data);

						// 2025/12/15 change: Redirect to checkout is not supported anymore
						// https://docs.stripe.com/changelog/clover/2025-09-30/remove-redirect-to-checkout
						window.location.href = data.results!.redirectURL;
						// // documentation:
						// // https://stripe.com/docs/js/checkout/redirect_to_checkout
						// stripe!.redirectToCheckout({
						// 	sessionId: data.results!.sessionId,
						// })
						// 	.then(function (result: wts_ignore_any) {
						// 		// If redirection fails, display an error to the customer.
						// 		if (result.error) {
						// 			console.error(`Error from stripe.redirectToCheckout: 
						// 			${result.error.message}`);
						// 			//reportErrorToUser(`Cound not redirect to Stripe service: ${result.error.message}`);
						// 		}
						// 	})
						// 	.catch((err: unknown) => {
						// 		console.error(`Exception from 'stripe.redirectToCheckout'`, err);
						// 		//reportErrorToUser('Could not redirect window to the Stripe service');
						// 	});
					}
					else {
						console.error(`Error from '/purchase/report': 
							${data.err}`)
					}
				})
					.catch((err: unknown) => {
						console.error(`Exception from '/purchase/report': `, err);
					});
				});
//				window.stripe = Stripe(publicKeyResult.publicKey);

				
			}
			else { // error from /payment/public-key
				console.error(`Error from '/payment/public-key': `, publicKeyResult.err);
				//reportErrorToUser('Could not retrieve stripe public key from the server');
			}
		})
		.catch((err: unknown) => { // error from /payment/public-key
			console.error(`Exception from '/payment/public-key': `, err);
			//reportErrorToUser('Could not retrieve Stripe public key');
		});

};